// extracted by mini-css-extract-plugin
export var card = "_l6-5";
export var cardSelected = "_l6-4";
export var image = "_l6-3";
export var modal = "_l6-0";
export var modalContent = "_l6-1";
export var table = "_l6-2";